module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/2@2x_dc0c6f409598ddad396c765b433f9041.png";